//*************************************************************************************
//* Session specific code
//*
//* 6/13/18 Kraus    [COM-136]: Created
//*************************************************************************************

app.KendoGrids = (function () {
    var options = [];
    var myKendoGrids = {
        InitPersistentGrid: function (gridId, loadData) {
            kendo.ui.progress($("#" + gridId), true);
            $.ajax({
                type: 'POST',
                url: "/PersistentState/Get",
                data: "GridIdSelector=" + gridId,
                success: function (results) {
                    if (results) {
                        options[gridId] = results.Options;
                        if (results.Filter) {
                            $("form[data-role='" + $("#" + gridId).data("filter-form") + "']").deserialize(results.Filter);
                        }
                    }

                    $("#" + gridId).data("kendoGrid").bind("dataBound", function (e) { app.KendoGrids.SaveOptions(gridId); });
                    $("#" + gridId).data("kendoGrid").bind("columnMenuInit", function (e) {
                        var menu = e.container.find(".k-menu");
                        $("input", menu).on('click', function () { app.KendoGrids.SaveOptions(gridId); });
                    });
                    
                    if (loadData) {
                        app.KendoGrids.GetResults(gridId);
                    }
                    else {
                        kendo.ui.progress($("#" + gridId), false);
                    }
                },
                error: function (results) {
                    kendo.ui.progress($("#" + gridId), false);
                }
            });

            //setup the save event listender
            var selectorString = "#" + gridId;
            var formSelector = "form[data-role='" + $("#" + gridId).data("filter-form") + "']";
            if ($(formSelector).length > 0) {
                selectorString = selectorString + ", " + formSelector;
            }

            $("form[data-role='" + $("#" + gridId).data("filter-form") + "']").on("keypress keydown",
                function (e) {
                    if (e.keyCode === 13 && $(event.target).is("input[type='text']")) {
                        e.preventDefault();
                        app.KendoGrids.GetResults(gridId);
                        return false;
                    }
                });

            $("[data-clear-form]").on("click",
                function (e) {
                    $("form[data-role='" + $(this).data("clear-form") + "']").find("input[type=text], select, textarea").val("").prop('checked', false);

                });

            $(selectorString).on('click', 'button, a, input[type=checkbox]', function (e) {
                app.KendoGrids.SaveOptions(gridId);
            });

            $("[data-update-grid-id='" + gridId + "']").on('click', function (e) {
                app.KendoGrids.GetResults($(this).data("update-grid-id"));
            });


            //setup save listeners for menu in kendo

        },
        SaveOptions: function (gridId) {
            currentOptions = $("#" + gridId).data("kendoGrid").getOptions();
            currentOptions.dataSource.data = {};
            currentOptions.data = {};
            currentOptions.excel = {};
            options[gridId] = kendo.stringify(currentOptions);
            var encodedOptionsString = encodeURIComponent(kendo.stringify(currentOptions));
            var encodedFilterString = encodeURIComponent($("input:not([data-not-persistent]), select:not([data-not-persistent]), textarea:not([data-not-persistent]), radio:not([data-not-persistent])", "form[data-role='" + $("#" + gridId).data("filter-form") + "']").serialize());

            $.ajax({
                type: 'POST',
                url: "/PersistentState/Save",
                data: "Options=" + encodedOptionsString + "&GridIdSelector=" + gridId + "&Filter=" + encodedFilterString,
                success: function (results) {
                    var hello = true;
                },
                error: function (results) {
                }
            });
        },
        OptionsExist: function (gridId) {
            if (options[gridId] !== undefined) { return true; }
            return false;
        },
        LoadOptions: function (gridId, datasource) {
            var parsedOptions;
            if (app.KendoGrids.OptionsExist(gridId)) {
                //console.log("loaded");
                parsedOptions = JSON.parse(options[gridId]);
            }
            else {
                parsedOptions = $("#" + gridId).data("kendoGrid").getOptions();
                options[gridId] = kendo.stringify(parsedOptions);
            }

            if (datasource !== null) {
                parsedOptions.dataSource.data = datasource.options.data;
            }

            //set export options
            if (parsedOptions.excel.length == undefined) {
                parsedOptions.excel = {
                    proxyUrl: null,
                    allPages: false,
                    filterable:false,
                    fileName: eval($("#" + gridId).attr('data-file-name'))
                };
            }

            $("#" + gridId).data("kendoGrid").setOptions(parsedOptions);
        },
        GetResults: function (gridId) {
            var grid = $("#" + gridId);
            kendo.ui.progress($(grid), true);
            $.ajax({
                type: 'POST',
                url: $(grid).data("url"),
                data: $("form[data-role='" + $(grid).data("filter-form") + "']").serialize(),
                success: function (results) {
                    var dataSource = new kendo.data.DataSource({ data: results });
                    app.KendoGrids.LoadOptions(gridId, dataSource);
                    kendo.ui.progress($(grid), false);
                    if ($("#grdActivityLog").length > 0 && gridId !=='grdActivityLog') {
                        app.ActivityLog.GetActivityLogResults();
                    }
                    $(document).trigger("kendo-datasource-load-complete", this);
                },
                error: function (results) {
                    kendo.ui.progress($(grid), false);
                }
            });
        }

    };
    return myKendoGrids;
}());

jQuery.fn.deserialize = function (data) {
    var f = this,
        map = {},
        find = function (selector) { return f.is("form") ? f.find(selector) : f.filter(selector); };
    //Get map of values
    jQuery.each(data.split("&"), function () {
        var nv = this.split("="),
            n = decodeURIComponent(nv[0]),
            v = nv.length > 1 ? decodeURIComponent(nv[1]) : null;
        if (!(n in map)) {
            map[n] = [];
        }
        map[n].push(v);
    });
    //Set values for all form elements in the data
    jQuery.each(map, function (n, v) {
        find("[name='" + n + "']").val(v);
    });
    //Clear all form elements not in form data
    find("input:text:not([data-not-persistent]),select:not([data-not-persistent]),textarea:not([data-not-persistent])").each(function () {
        if (!(jQuery(this).attr("name") in map)) {
            jQuery(this).val("");
        }
    });
    find("input:checkbox:checked:not([data-not-persistent]),input:radio:checked:not([data-not-persistent])").each(function () {
        if (!(jQuery(this).attr("name") in map)) {
            this.checked = false;
        }
    });
    return this;
}